export default __webpack_public_path__ + "static/media/wba.eb3c166a.svg";